import React from 'react';
import './error.scss';

const bwCoreLogo = require('./../../images/best_western_logo.png');

class Error extends React.Component {

  render() {
    return (
      <div className="error-component BWCore">
        <div className="error-component__logo-wrap text-center">
          <img className="error-component__logo" src={bwCoreLogo} alt="Best Western" />
          <a className="error-component__link btn btn-link" href="https://www.bestwestern.it">bestwestern.it</a>
        </div>
      </div>
    );
  }
}

Error.displayName = 'PagesError';
Error.propTypes = {};
Error.defaultProps = {};

export default Error;



// WEBPACK FOOTER //
// ./components/pages/Error.js